/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { ValueType } from 'hems/common/utils';

export const TOAST_MESSAGE_STATUS_TYPE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;

export type ToastMessageStatusTypeValue = ValueType<typeof TOAST_MESSAGE_STATUS_TYPE>;
